import store from '@/store'

const hasAccessGuard = async (to, from, next) => {

    const token = store.getters["auth/getToken"]
    const refreshToken = store.getters["auth/getRefreshToken"]
    const routeRedirect = store.getters['auth/getRouteRedirect']

    if (token && refreshToken) {
        return next({name: routeRedirect})
    }

    return next()

}

export default hasAccessGuard